export default {
  validate(files, value) {
    let success = true;
    const size = Number(value[0]) * 1024 * 1024;

    files.forEach(file => {
      if (file.size > size) {
        success = false;
      }
    });

    return success;
  },
};
